import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ProductUnitPostfixApi, ProductUnitPrefixApi } from 'api';
import { RootState } from 'app';

export const findProductUnitPostfix = createAsyncThunk(
  'productUnit/findProductUnitPostfix',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ProductUnitPostfixApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findProductUnitPrefix = createAsyncThunk(
  'productUnit/findProductUnitPrefix',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ProductUnitPrefixApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  prefixList: any[];
  postfixList: any[];
  prefixObj: Record<string, any>;
  postfixObj: Record<string, any>;
}

const initialState: IState = {
  prefixList: [],
  postfixList: [],
  prefixObj: {},
  postfixObj: {},
};

const productUnitSlice = createSlice({
  name: 'productUnit',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findProductUnitPrefix.fulfilled, (state, action) => {
      const { data } = action.payload;
      const list = (data || []).map(item => {
        return {
          ...item,
          name: item.name || 'bỏ trống',
          key: item.id,
          value: item.id,
        };
      });
      const obj = (data || []).reduce((prevVal, curVal) => {
        prevVal[curVal.id] = {
          ...curVal,
        };
        return prevVal;
      }, {});

      state.prefixList = list;
      state.prefixObj = obj;
    });
    builder.addCase(findProductUnitPostfix.fulfilled, (state, action) => {
      const { data } = action.payload;
      const list = (data || []).map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });
      const obj = (data || []).reduce((prevVal, curVal) => {
        prevVal[curVal.id] = {
          ...curVal,
        };
        return prevVal;
      }, {});

      state.postfixList = list;
      state.postfixObj = obj;
    });
  },
});

const { reducer: productUnitReducer } = productUnitSlice;

export default productUnitReducer;

export const selectProductUnit = (state: RootState): IState =>
  state.productUnit as IState;
